'use client'

import { NotificationStatus, useToastContext } from '@morpho-org/ui-v6/contexts'
import { useCallback } from 'react'

import { SetTargetChainEvent } from '@/contexts/Web3Context'
import LedgerWalletProvider from '@/contexts/Web3Context/LedgerWalletProvider'
import { CHAIN_SWITCH_FAILED_MESSAGE } from '@/contexts/Web3Context/utils/switchChain'
import Web3Provider, { type Web3ProviderProps } from '@/contexts/Web3Context/Web3Provider'

const CHAIN_SWITCH_SUCCESS_TOAST_DURATION_MS = 4000

const InterfaceWeb3Provider = ({
  children,
  cookies
}: Omit<Web3ProviderProps, 'onSetTargetChainEvent'>) => {
  const { displayToast } = useToastContext()

  const onSetTargetChainEvent = useCallback<
    Exclude<Web3ProviderProps['onSetTargetChainEvent'], undefined>
  >(
    evt => {
      switch (evt.type) {
        case SetTargetChainEvent.success: {
          // Display a success toast on successful chain switch.
          displayToast({
            description: `Wallet network successfully switched to ${evt.chain.name}.`,
            notificationStatus: NotificationStatus.success,
            duration: CHAIN_SWITCH_SUCCESS_TOAST_DURATION_MS
          })
          break
        }
        case SetTargetChainEvent.error: {
          // A declined switch is the user's own choice; only surface real failures.
          if (evt.isUserRejection) break
          displayToast({
            description: CHAIN_SWITCH_FAILED_MESSAGE(evt.chain.name),
            notificationStatus: NotificationStatus.error
          })
          break
        }
      }
    },
    [displayToast]
  )

  return (
    <>
      <LedgerWalletProvider />
      <Web3Provider cookies={cookies} onSetTargetChainEvent={onSetTargetChainEvent}>
        {children}
      </Web3Provider>
    </>
  )
}

export default InterfaceWeb3Provider
